import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import BenefitIcon from "@/components/BenefitIcon";

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.post(slug).then((r) => setPost(r.post)).catch(() => setPost(null)); }, [slug]);

  if (!post) return <div className="max-w-site mx-auto px-6 md:px-10 py-24 label">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24" data-testid="journal-post">
      <Link to="/journal" className="label underline" data-testid="post-back">← Journal</Link>
      <div className="mt-8 label !text-[10px]">{post.category} · {post.read_time} · {post.date}</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-[-0.03em] leading-[1.0] mt-4">{post.title}</h1>
      <div className="mt-10 aspect-[16/9] border border-[color:var(--line)] bg-[color:var(--bg-soft)] overflow-hidden">
        <img src={post.cover} alt={post.title} className="w-full h-full object-cover" />
      </div>
      <div className="mt-10 space-y-5 text-[17px] leading-[1.7] text-[color:var(--ink-2)]">
        {post.body.map((p, i) => (<p key={i}>{p}</p>))}
      </div>

      {Array.isArray(post.claims) && post.claims.length > 0 && (
        <section className="mt-14 pt-10 border-t border-[color:var(--line)]" data-testid="post-claims">
          {post.claims_intro && (
            <h2 className="font-display text-2xl md:text-3xl tracking-[-0.02em] leading-[1.1]">
              {post.claims_intro.split(",").map((part, i, arr) => (
                <React.Fragment key={i}>
                  {i === arr.length - 1 ? (
                    <span className="editorial normal-case">,{part}</span>
                  ) : (
                    part
                  )}
                </React.Fragment>
              ))}
            </h2>
          )}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 border border-[color:var(--line)]">
            {post.claims.map((c, i) => (
              <div
                key={c.kind}
                className={`border-b border-[color:var(--line)] ${i % 2 === 0 ? "md:border-r" : ""} md:[&:nth-last-child(-n+2)]:border-b-0`}
                data-testid={`post-claim-${c.kind}`}
              >
                <div className="p-7 md:p-8 h-full flex flex-col md:flex-row gap-5 md:gap-6">
                  <div className="shrink-0 text-[color:var(--ink)]">
                    <BenefitIcon kind={c.kind} className="w-10 h-10 md:w-12 md:h-12" />
                  </div>
                  <div className="flex-1">
                    <div className="label !text-[10px] mb-3">{c.eyebrow}</div>
                    <ul className="space-y-2.5">
                      {c.items.map((item) => (
                        <li
                          key={item}
                          className="flex items-start gap-3 text-[14px] leading-snug text-[color:var(--ink-2)]"
                        >
                          <span className="shrink-0 w-1 h-1 mt-[0.55rem] bg-[color:var(--ink)]" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {post.claims_disclaimer && (
            <p className="mt-6 label !text-[10px] !text-[color:var(--ink-3)] !tracking-[0.15em]">
              {post.claims_disclaimer}
            </p>
          )}
        </section>
      )}
    </article>
  );
}
